<script lang="ts">
  import {LOADERS, STATES} from './utils';

  export let loader: () => Promise<unknown>;
  // 超时配置
  export let timeout = 3000;
  // 控制何时启动
  export let start = false;

  let state: number = STATES.INITIALIZED;
  let component;

  $: start && initState(loader);

  function initState(componentLoader) {
    state = STATES.INITIALIZED;
    component = undefined;

    if (LOADERS.has(componentLoader)) {
      state = STATES.SUCCESS;
      component = LOADERS.get(componentLoader);
    } else {
      try {
        loadComponent(componentLoader, timeout);
      } catch {
        state = STATES.SUCCESS;
        component = componentLoader;
      }
    }
  }

  async function loadComponent(componentLoader, _timeout) {
    state = STATES.LOADING;
    try {
      const componentModule = await Promise.race([
        componentLoader(),
        new Promise((resolve, reject) => {
          setTimeout(() => reject('Timeout'), _timeout);
        }),
      ]);
      component = componentModule.default || componentModule;
      state = STATES.SUCCESS;
      LOADERS.set(componentLoader, component);
    } catch (error) {
      state = error === 'Timeout' ? STATES.TIMEOUT : STATES.ERROR;
    }
  }
</script>

{#if state === STATES.ERROR}
  <slot name="error" />
{:else if state === STATES.TIMEOUT}
  <slot name="timeout" />
{:else if state === STATES.LOADING}
  <slot name="loading" />
{:else if state === STATES.SUCCESS}
  {#if $$slots.success}
    <slot name="success" {component} />
  {:else if $$slots.default}
    <slot {component} />
  {:else}
    <svelte:component this={component} {...$$restProps} />
  {/if}
{/if}
